<div matTooltip="Specifications: {{value}}">
    <div *ngIf="exists" style="background-color: rgb(160, 160, 64); height: 24px; width: 12px">&nbsp;</div>
    <div *ngIf="!exists" style="background-color: rgb(223, 223, 189); height: 24px; width: 12px">&nbsp;</div>
</div>

